<template>
	<div
		class="popups-container"
		v-if="
			user.showPoolInformationDialog ||
			modalOwk ||
			showConfirmModal ||
			(expired && isDashboard) ||
			(isLearning && showCookieYTModal) ||
			showSsoUserModal ||
			showEditDataModal
		"
	>
		<div class="container popups-container-content">
			<!--  COOKIE YT MODAL -->
			<div
				v-if="isLearning && showCookieYTModal"
				class="d-flex justify-content-center message"
			>
				<div
					class="modal p-0"
					style="
						box-shadow: 0px 1px 2px rgb(0 0 0 / 22%),
							0px 0px 1px rgb(0 0 0 / 32%);
					"
				>
					<app-border-top />
					<div class="p-3">
						<div class="text-center my-2">
							<img
								style="max-width: 200px"
								src="images/m-bank-ui-illustrations-retail-cross-mark-woman.svg"
								alt="Akceptacja cookies"
							/>
						</div>
						<div class="px-3">
							Nie możemy Ci pokazać wideo na stronie bez Twojej
							zgody na ciasteczka analityczne i marketingowe.
							Wynika to z ograniczeń technicznych. Zmień zgodę w
							<span
								@click="openCookieModal"
								style="color: #00801f; cursor: pointer"
								>Ustawieniach cookie</span
							>
						</div>
						<div class="modal-content d-flex justify-content-end">
							<button
								@click="
									$store.commit('setCookieYTModal', false)
								"
								type="button"
								class="btn btn-secondary mt-2"
							>
								Zamknij
							</button>
						</div>
					</div>
				</div>
			</div>
			<!--  NOWY MODAL -->
			<div v-if="modalOwk" class="d-flex justify-content-center message">
				<div
					class="modal p-0"
					style="
						box-shadow: 0px 1px 2px rgb(0 0 0 / 22%),
							0px 0px 1px rgb(0 0 0 / 32%);
					"
				>
					<app-border-top />
					<div class="pl-4 pr-5 pb-4 pt-3" style="position: relative">
						<div class="d-flex justify-content-end">
							<img
								@click="closeValidateDataDialog"
								src="images/learning/close.svg"
								alt
								style="
									cursor: pointer;
									position: absolute;
									top: 25px;
									right: 10px;
								"
							/>
						</div>
						<div class="modal-content p-0">
							<h3 style="line-height: 32px">
								Czy Twoje dane w naszym systemie są aktualne?
							</h3>
							<p>
								Mamy do Ciebie bardzo ważne pytanie: czy Twoje
								dane w naszym systemie są aktualne?
							</p>
							<h3 class="pt-0" style="line-height: 32px">
								Sprawdź to koniecznie, szczególnie zwróć uwagę
								na dokument tożsamości.
							</h3>
							<p>Prosimy, potwierdź lub uaktualnij swoje dane.</p>
							<p>
								To bardzo ważne dla prawidłowej obsługi Twojego
								rachunku.
							</p>
						</div>
						<div class="modal-content pl-0">
							<button @click="goToMyFx" class="btn btn-primary">
								Potwierdź / Zmień dane
							</button>
							<button
								@click="closeValidateDataDialog"
								class="btn btn-secondary mt-2"
								type="button"
							>
								Przypomnij później
							</button>
						</div>
					</div>
				</div>
			</div>

			<mifid-modal v-if="user.showPoolInformationDialog" />
			<app-modal
				v-if="expired"
				:modalIcon="'modal-info.svg'"
				:title="'Data ważności dowodu osobistego upłynęła.'"
				:buttons="[
					{ text: 'Zamknij', css: 'btn btn-primary expired-btn' },
				]"
				@btnClick="closeDocumentExpired"
			>
				<div class="expire-info">
					<p>
						<b>Zaktualizuj dane w sekcji Rachunki</b>
						<img src="images/chewron-gray.svg" />
						<b>
							<router-link style="color: #0e872b" to="/MyFx"
								>moje dane</router-link
							>
						</b>
					</p>
				</div>
			</app-modal>
			<app-modal
				v-if="showConfirmModal"
				:modalIcon="'modal-success.svg'"
				:title="'Złożono dyspozycję wypłaty'"
				:buttons="[
					{ css: 'btn btn-primary', text: 'POWRÓT DO MÓJ FX' },
				]"
				@btnClick="closeConfirmModal"
			>
				<b>Orientacyjne czasy realizacji wypłat:</b>
				<ul>
					<li>
						<b>Pomiędzy rachunkami OTC:</b> realizacja
						natychmiastowa
					</li>
					<li>
						<b>W ramach Biura maklerskiego mBanku:</b> realizacja do
						10 minut
					</li>
					<li>
						<b>W ramach Grupy mBanku:</b> 8:00-17:30 (dni robocze),
						realizacja do 45 minut
					</li>
					<li>
						<b>Banki poza Grupą mBanku:</b> w zależności od sesji
						Elixir (BM mBanku obsługuje również III sesję Elixir)
					</li>
				</ul>
			</app-modal>
			<app-modal
				v-if="showSsoUserModal"
				:modalIcon="'modal-info.svg'"
				:title="'Logowanie do MyFx'"
				:buttons="[{ css: 'btn btn-primary', text: 'Zamknij' }]"
				@btnClick="closeSsoUserModal"
			>
				<div class="mb-2">
					Drogi użytkowniku, za
					<span style="color: red; font-weight: bold"
						>{{ howManyDaysLeft }} dni</span
					>
					utracisz możliwość logowania się do panelu MyFX
					dotychczasowymi danymi. Po tym czasie, dostęp do MyFX
					uzyskasz wybierając opcję logowania poprzez konto w mBanku.
				</div>
			</app-modal>
			<app-modal
				v-if="showEditDataModal"
				:modalIcon="'modal-info.svg'"
				:title="'Edycja danych i zakładanie nowego rachunku'"
				:buttons="[{ css: 'btn btn-primary', text: 'Zamknij' }]"
				@btnClick="closeEditDataModal"
			>
				<div class="mb-2">
					Szanowny użytkowniku, Informujemy, że Twoje konto jest w
					trakcie migracji. W związku z tym przez pewien czas nie
					będziesz miał możliwości edytowania swoich danych ani
					zakładania nowych rachunków. Przepraszamy za wszelkie
					niedogodności i dziękujemy za wyrozumiałość.
				</div>
			</app-modal>
		</div>
	</div>
</template>

<script>
import AppModal from '@/components/AppModal';
import MifidModal from '@/views/dashboard/partial/_MifidModal';
import AppBorderTop from '@/components/AppBorderTop';

export default {
	components: {
		AppModal,
		MifidModal,
		AppBorderTop,
	},
	computed: {
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		modalOwk() {
			return this.$store.getters.getModalOwk
				? this.$store.getters.getModalOwk
				: false;
		},
		showConfirmModal() {
			return this.$store.getters.getShowModalPayoutSuccess;
		},
		expired() {
			return this.$store.getters.getDocumentExpired
				? this.$store.getters.getDocumentExpired
				: false;
		},
		isDashboard() {
			return this.$route.name === 'dashboard';
		},
		isLearning() {
			return this.$route.name === 'eLearning';
		},
		showCookieYTModal() {
			return this.$store.getters.getCookieYTModal;
		},
		showSsoUserModal() {
			return this.$store.getters.getShowSsoModal;
		},
		howManyDaysLeft() {
			return this.$store.getters.getAmountOfDaysLeft;
		},
		showWarningAboutMigrationModal() {
			return this.$store.getters.getShowSsoModal;
		},
		showEditDataModal() {
			return this.$store.getters.getShowCanEditClientDataModal;
		},
	},
	methods: {
		closeDocumentExpired() {
			this.$store.commit('setDocumentExpired', false);
		},
		closeConfirmModal() {
			this.$store.commit('setShowModalPayoutSuccess', false);
		},
		closeValidateDataDialog() {
			this.$store.commit('setModalOwk', false);
		},
		goToMyFx() {
			this.closeValidateDataDialog();
			this.$router.push('/MyFx');
		},
		// Wyświetlenie modala Cookie - mbiscuit z gtm mBanku
		openCookieModal() {
			this.$store.commit('setCookieYTModal', false);
			// eslint-disable-next-line
			mbiscuit.open();
		},
		closeSsoUserModal() {
			this.$store.commit('setShowSsoModal', false);
		},
		closeEditDataModal() {
			this.$store.commit('setShowCanEditClientDataModal', false);
		},
	},
};
</script>
